/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

import Client from "./clients/rest";

/**
 * This Auth repo is for all the authentication api calls
 * that will be done inside the app like:
 * Login with email and password,
 * OTP login,
 * Forget password,
 * ...
 */
export default {
    loginWithEmailAndPassword(username, password, captcha,hash_code) {
        return Client.post(
            "/connect/token",
            {
                username,
                password,
                hashcode: hash_code
               // acoustic :window.ewt.getVisitorKey()
            },
            {
                headers: { "X-CAPTCHA": captcha },
            }
        );
    },

    otpLoginGenerate(businessNumber, phoneNumber, captcha, hash) {
        return Client.post(
            "/connect/otp/generate",
            {
                business_number: businessNumber,
                phone: phoneNumber,
                hashcode: hash //to outo fill otp in android
            },
            {
                headers: { "X-CAPTCHA": captcha },
            }
        );
    },

    otpLogin(otpSession, otpCode, hash_code) {
        return Client.post("/connect/otp", {
            username: otpSession,
            password: otpCode,
            hashcode: hash_code
        });
    },

    forgetPassword(email, captcha) {
        return Client.put(
            "/connect/password/forget",
            {
                email,
            },
            {
                headers: { "X-CAPTCHA": captcha },
            }
        );
    },

    activateAccount(password, token, captcha) {
        return Client.put(
            "/connect/password/activate",
            {
                password,
                token
            },
            {
                headers: { "X-CAPTCHA": captcha },
            }
        );
    },

    resetPassword(password, token, captcha) {
        return Client.put(
            "/connect/password/reset",
            {
                password,
                token,
            },
            {
                headers: { "X-CAPTCHA": captcha },
            }
        );
    },

    //getSelfServiceApiKey() {
    //    return Client.get("/auth/api_diy_token");
    //},

    getOfirKey(business_id) {
        return Client.get(`/ppa/token/${business_id}`);
    },
};
